






















import Vue from 'vue';
import { defineComponent, onMounted } from '@vue/composition-api';
import HTextarea from '@/ui/components/base/HTextarea.vue';
import HButton from '@/ui/components/base/HButton.vue';
import useCommentVariables from '@/ui/composables/review-actions/use-comment-variables';
import useReviewActionsVariables from '@/ui/composables/review-actions/use-review-actions-variables';
import useCommentFunctions from '@/ui/composables/review-actions/use-comment-functions';
import { iReview } from '../../../entities/review/review.types';

export default defineComponent({
  name: 'ReviewComment',
  components: {
    HTextarea,
    HButton,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root, emit }) {
    const reviewActionsVariables = useReviewActionsVariables();
    const commentVariables = useCommentVariables();
    const commentFunctions = useCommentFunctions(
      commentVariables,
      reviewActionsVariables,
      root.$store,
      emit,
    );

    onMounted(() => {
      const { reviewInstance } = reviewActionsVariables;
      Vue.set(reviewInstance, 'value', props.review as iReview);
    });

    return {
      ...commentVariables,
      ...commentFunctions,
    };
  },
});
